import React from 'react';
import {Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/Send";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";

const UserAutocompleteMenuItem = ({suggestion, onSendSuggestion, replacedString}) => {
    return (
        <MenuItem
            key={suggestion.id}
            style={{justifyContent: 'space-between', paddingRight: 0, whiteSpace: 'normal', minHeight: '40px' }}
            onClick={() => onSendSuggestion(suggestion.question)}
        >
            <Typography style={{ overflow: "wrap" , fontSize:"13px" }}>
                <span dangerouslySetInnerHTML={{__html: replacedString}}></span>
            </Typography>
            <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                <IconButton onClick={(e) => {
                        e.stopPropagation()
                        onSendSuggestion(suggestion.question)
                    }}
                    disableRipple
                >
                </IconButton>
            </div>
        </MenuItem>
    );
};

UserAutocompleteMenuItem.propTypes = {
    suggestion: PropTypes.object.isRequired,
    replacedString: PropTypes.string.isRequired,
    onSendSuggestion: PropTypes.func.isRequired,
}

export default UserAutocompleteMenuItem;